import { AxiosResponse } from "axios"
import { call, select, takeEvery } from "redux-saga/effects"
import { AppService } from "src/services/app"
import { getBaseUrl } from "../selectors/features/app"
import { RequestTypes } from "../types"

const appservice = new AppService()

function* getBulkSendStatusSaga(action: any) {
  const { payload } = action
  const { id } = payload
  try {
    const baseUrl: string = yield select(getBaseUrl)
    const response: AxiosResponse<any> = yield call(appservice.getBulkSendStatus, baseUrl, id)
    payload?.cbSuccess && payload?.cbSuccess({ ...response })
  } catch (error: any) {
    payload?.cbFailure && payload?.cbFailure(error?.statusText || "status failed")
  }
}

// takeEvery, not takeLatest, so rapid poll ticks are not cancelled by each other
export function* watchGetBulkSendStatus() {
  yield takeEvery(RequestTypes.GET_BULK_SEND_STATUS, getBulkSendStatusSaga)
}
